const oktaDomain = 'https://onewp.okta.com';
const clientId = process.env.REACT_APP_OKTA_CLIENT_ID;
const redirectUri = `${window.location.origin}/login/callback`;

export const oktaAuthConfig = {
  issuer: `${oktaDomain}/oauth2/default`,
  clientId,
  redirectUri
};

export const oktaSignInConfig = {
  baseUrl: oktaDomain,
  clientId,
  redirectUri,
  logo: '//logo.clearbit.com/okta.com'
};
